import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import DialogObjetivoV2DashboardVendedorFaturas from "pages/components/DialogObjetivoV2DashboardVendedorFaturas";
import DialogObjetivoV2DashboardEquipaFaturas from "pages/components/DialogObjetivoV2DashboardEquipaFaturas";

import Draggable from "react-draggable";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

function fmtNumero(value, casas = 2) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const n = Number(value);

  if (!Number.isFinite(n)) {
    return "-";
  }

  return n.toLocaleString("pt-PT", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function fmtPercentagem(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const n = Number(value);

  if (!Number.isFinite(n)) {
    return "-";
  }

  return `${n.toLocaleString("pt-PT", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}%`;
}

function casasValor(metrica, modo) {
  const m = String(metrica || "")
    .trim()
    .toUpperCase();

  const md = String(modo || "")
    .trim()
    .toUpperCase();

  if (m === "CLIENTES") {
    return md === "MEDIA" ? 3 : 0;
  }

  if (m === "QTD") return 0;
  if (m === "EUROS") return 2;
  if (m === "LITROS") return 3;

  return 2;
}

const thStyle = {
  textAlign: "left",
  padding: "10px 8px",
  fontSize: 12,
  color: "#7b809a",
  fontWeight: 700,
};

const tdStyle = {
  padding: "10px 8px",
  fontSize: 13,
  borderBottom: "1px solid #eeeeee",
};

export default function DialogObjetivoV2DashboardDetalhe({ open, onClose, objetivo }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loading, setLoading] = useState(false);
  const [detalhe, setDetalhe] = useState(null);
  const [erro, setErro] = useState("");

  const [vendedorFaturas, setVendedorFaturas] = useState(null);
  const [equipaFaturas, setEquipaFaturas] = useState(null);

  const modosClientesOptions = [
    { value: "rota", label: "Clientes da rota" },
    { value: "todos", label: "Todos os clientes" },
  ];

  const [modoClientes, setModoClientes] = useState(modosClientesOptions[1]);

  const isSubmarcas =
    String(objetivo?.metrica || "")
      .trim()
      .toUpperCase() === "SUBMARCAS";

  useEffect(() => {
    if (!open || !objetivo?.id) {
      setDetalhe(null);
      setErro("");
      return;
    }

    let ativo = true;

    const carregar = async () => {
      setLoading(true);
      setErro("");

      try {
        const [data, err] = await handleApi(
          isSubmarcas
            ? api.post("Comercial/SelObjetivoV2SubmarcasMatriz", {
                id: objetivo.id,
                refvendedor: "",
                modoclientes: modoClientes?.value || "todos",
                atribuicaovendedor: "EFETIVO",
              })
            : api.post("Comercial/SelObjetivoV2DashboardDetalhe", {
                id: objetivo.id,
              })
        );

        if (!ativo) return;

        if (err) {
          setDetalhe(null);
          setErro(err);
          return;
        }

        setDetalhe(data || null);
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [open, objetivo?.id, isSubmarcas, modoClientes?.value]);

  const casas = useMemo(
    () => casasValor(detalhe?.objetivo?.metrica, detalhe?.objetivo?.patamares_modo),
    [detalhe?.objetivo?.metrica, detalhe?.objetivo?.patamares_modo]
  );

  const submarcas = Array.isArray(detalhe?.submarcas) ? detalhe.submarcas : [];

  const equipas = Array.isArray(detalhe?.equipas) ? detalhe.equipas : [];

  const vendedores = Array.isArray(detalhe?.vendedores) ? detalhe.vendedores : [];

  const linhasSubmarcas = Array.isArray(detalhe?.linhas) ? detalhe.linhas : [];

  const colunasSubmarcas = useMemo(() => {
    const cols = [
      {
        Header: "Cliente",
        id: "cliente",
        accessor: (row) => {
          const nome = row?.cliente || row?.refcliente || "";
          const nif = row?.nif || "";

          return nif ? `${nome} (${nif})` : nome;
        },
        width: 300,
        minWidth: 220,
        maxWidth: 500,
      },
      {
        Header: "Vendedor",
        id: "vendedor",
        accessor: (row) => row?.vendedor || row?.refvendedor || "",
        width: 220,
        minWidth: 160,
        maxWidth: 350,
      },
      {
        Header: "Total",
        accessor: "total",
        width: 80,
        minWidth: 70,
        maxWidth: 90,
        align: "center",
        sortType: "numPt",
        Cell: ({ value }) => Number(value || 0),
      },
    ];

    submarcas.forEach((s) => {
      const ref = String(s?.ref || "").trim();

      if (!ref) return;

      cols.push({
        Header: s?.nome || ref,
        accessor: `sm_${ref}`,
        filterType: "simNao",
        width: 125,
        minWidth: 110,
        maxWidth: 180,
        align: "center",
        Cell: ({ value }) =>
          Number(value || 0) === 1 ? <span style={{ fontSize: 16, lineHeight: 1 }}>✔</span> : "",
      });
    });

    return cols;
  }, [submarcas]);

  const nomeObjetivo = detalhe?.objetivo?.nome || objetivo?.objetivo_nome || "";

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        PaperComponent={isMobile ? undefined : PaperComponent}
        PaperProps={{
          sx: {
            width: {
              xs: "100%",
              sm: "calc(100% - 48px)",
            },
            maxHeight: {
              xs: "100%",
              sm: "92vh",
            },
          },
        }}
      >
        <DialogTitle
          className="draggable-dialog-title"
          sx={{
            cursor: {
              xs: "default",
              sm: "move",
            },
          }}
        >
          <MDTypography variant="h5">{nomeObjetivo || "Detalhe do objetivo"}</MDTypography>

          <MDTypography variant="button" color="text" display="block" mt={0.5}>
            {isSubmarcas ? "Submarcas compradas por cliente" : "Detalhe por vendedor"}
          </MDTypography>
        </DialogTitle>

        <DialogContent dividers>
          {loading && (
            <MDBox py={4} display="flex" justifyContent="center">
              <CircularProgress />
            </MDBox>
          )}

          {!loading && erro && (
            <MDBox py={2}>
              <MDTypography variant="button" color="error">
                {erro}
              </MDTypography>
            </MDBox>
          )}

          {!loading && !erro && detalhe && (
            <>
              {isSubmarcas ? (
                <>
                  <MDBox
                    mb={2}
                    display="flex"
                    alignItems={{ xs: "stretch", sm: "flex-end" }}
                    justifyContent="space-between"
                    gap={2}
                    flexDirection={{ xs: "column", sm: "row" }}
                  >
                    <MDBox>
                      <MDTypography variant="button" color="text" display="block">
                        Clientes: <strong>{detalhe?.total_clientes || 0}</strong>
                      </MDTypography>

                      <MDTypography variant="button" color="text" display="block">
                        Submarcas selecionadas: <strong>{detalhe?.total_submarcas || 0}</strong>
                      </MDTypography>
                    </MDBox>

                    <MDBox sx={{ width: { xs: "100%", sm: 240 } }}>
                      <MDTypography variant="button" color="text" fontWeight="regular" mb={0.5}>
                        Clientes a considerar
                      </MDTypography>

                      <Autocomplete
                        size="small"
                        options={modosClientesOptions}
                        getOptionLabel={(option) => option?.label || ""}
                        value={modoClientes}
                        onChange={(_, value) => setModoClientes(value || modosClientesOptions[1])}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        renderInput={(params) => <TextField {...params} placeholder="Selecione…" />}
                        disableClearable
                      />
                    </MDBox>
                  </MDBox>

                  <ProjectTable
                    tableKey={`objetivo-v2-submarcas-${objetivo?.id || 0}`}
                    version="v1"
                    columns={colunasSubmarcas}
                    data={linhasSubmarcas}
                    loading={false}
                    emptyMessage="Sem clientes para apresentar."
                    minWidth={Math.max(900, 300 + 220 + 80 + submarcas.length * 125)}
                    maxHeight={isMobile ? "calc(100vh - 320px)" : "44vh"}
                    showKeepFilters
                  />
                </>
              ) : (
                <>
                  {submarcas.length > 0 && (
                    <MDBox mb={3}>
                      <MDTypography variant="button" color="text" display="block" mb={1}>
                        Submarcas selecionadas
                      </MDTypography>

                      <MDBox display="flex" flexWrap="wrap" gap={1}>
                        {submarcas.map((s) => (
                          <MDBox
                            key={s.refsubmarca}
                            sx={{
                              px: 1.5,
                              py: 0.75,
                              border: "1px solid #d9d9d9",
                              borderRadius: 1,
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <MDTypography
                              variant="button"
                              sx={{
                                fontSize: 13,
                                fontWeight: 600,
                              }}
                            >
                              {s.submarca || s.refsubmarca}
                            </MDTypography>
                          </MDBox>
                        ))}
                      </MDBox>
                    </MDBox>
                  )}

                  {equipas.length > 0 && (
                    <MDBox mb={3}>
                      <MDTypography variant="button" color="text" display="block" mb={1}>
                        Equipa
                      </MDTypography>

                      <MDBox
                        sx={{
                          overflowX: "auto",
                          maxWidth: "100%",
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            minWidth: 600,
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  ...thStyle,
                                  width: 48,
                                  minWidth: 48,
                                  maxWidth: 48,
                                }}
                              />
                              <th style={thStyle}>Equipa</th>
                              <th style={thStyle}>Objetivo</th>
                              <th style={thStyle}>Real</th>
                              <th style={thStyle}>Dif.</th>
                              <th style={thStyle}>%</th>
                            </tr>
                          </thead>

                          <tbody>
                            {equipas.map((row) => (
                              <tr key={`equipa-${row.referencia}`}>
                                <td
                                  style={{
                                    ...tdStyle,
                                    width: 48,
                                    minWidth: 48,
                                    maxWidth: 48,
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    color="info"
                                    title="Ver detalhe de vendas da equipa"
                                    onClick={() => setEquipaFaturas(row)}
                                  >
                                    <InfoOutlinedIcon fontSize="small" />
                                  </IconButton>
                                </td>

                                <td style={tdStyle}>{row.nome || row.referencia}</td>

                                <td style={tdStyle}>{fmtNumero(row.objetivo, casas)}</td>

                                <td style={tdStyle}>
                                  <strong>{fmtNumero(row.resultado, casas)}</strong>
                                </td>

                                <td
                                  style={{
                                    ...tdStyle,
                                    color:
                                      Number(row.diferenca) < 0
                                        ? "#f44335"
                                        : Number(row.diferenca) > 0
                                        ? "#4caf50"
                                        : undefined,
                                  }}
                                >
                                  {fmtNumero(row.diferenca, casas)}
                                </td>

                                <td style={tdStyle}>
                                  {fmtPercentagem(row.atingimento_percentagem)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </MDBox>
                    </MDBox>
                  )}

                  <MDBox mb={3}>
                    <MDTypography variant="button" color="text" display="block" mb={1}>
                      Individuais — detalhe por vendedor
                    </MDTypography>

                    <MDBox
                      sx={{
                        overflowX: "auto",
                        maxWidth: "100%",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth: 650,
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                ...thStyle,
                                width: 48,
                                minWidth: 48,
                                maxWidth: 48,
                              }}
                            />
                            <th style={thStyle}>Vendedor</th>
                            <th style={thStyle}>Objetivo</th>
                            <th style={thStyle}>Real</th>
                            <th style={thStyle}>Dif.</th>
                            <th style={thStyle}>%</th>
                          </tr>
                        </thead>

                        <tbody>
                          {vendedores.map((row) => (
                            <tr key={`vendedor-${row.referencia}`}>
                              <td
                                style={{
                                  ...tdStyle,
                                  width: 48,
                                  minWidth: 48,
                                  maxWidth: 48,
                                  paddingLeft: 4,
                                  paddingRight: 4,
                                }}
                              >
                                <IconButton
                                  size="small"
                                  color="info"
                                  title="Ver detalhe de vendas"
                                  onClick={() => setVendedorFaturas(row)}
                                >
                                  <InfoOutlinedIcon fontSize="small" />
                                </IconButton>
                              </td>

                              <td style={tdStyle}>{row.nome || row.referencia}</td>

                              <td style={tdStyle}>{fmtNumero(row.objetivo, casas)}</td>

                              <td style={tdStyle}>
                                <strong>{fmtNumero(row.resultado, casas)}</strong>
                              </td>

                              <td
                                style={{
                                  ...tdStyle,
                                  color:
                                    Number(row.diferenca) < 0
                                      ? "#f44335"
                                      : Number(row.diferenca) > 0
                                      ? "#4caf50"
                                      : undefined,
                                }}
                              >
                                {fmtNumero(row.diferenca, casas)}
                              </td>

                              <td style={tdStyle}>{fmtPercentagem(row.atingimento_percentagem)}</td>
                            </tr>
                          ))}

                          {vendedores.length === 0 && (
                            <tr>
                              <td
                                colSpan={6}
                                style={{
                                  ...tdStyle,
                                  textAlign: "center",
                                  color: "#7b809a",
                                }}
                              >
                                Sem objetivos individuais.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </MDBox>
                  </MDBox>

                  <MDBox>
                    <MDTypography variant="button" color="text" display="block" mb={1}>
                      Total Geral
                    </MDTypography>

                    <MDBox
                      sx={{
                        overflowX: "auto",
                        maxWidth: "100%",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth: 600,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={thStyle}>Tipo</th>
                            <th style={thStyle}>Objetivo</th>
                            <th style={thStyle}>Real</th>
                            <th style={thStyle}>Dif.</th>
                            <th style={thStyle}>%</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td
                              style={{
                                ...tdStyle,
                                fontWeight: 700,
                              }}
                            >
                              Total Geral
                            </td>

                            <td
                              style={{
                                ...tdStyle,
                                fontWeight: 700,
                              }}
                            >
                              {fmtNumero(detalhe?.total?.objetivo, casas)}
                            </td>

                            <td
                              style={{
                                ...tdStyle,
                                fontWeight: 700,
                              }}
                            >
                              {fmtNumero(detalhe?.total?.resultado, casas)}
                            </td>

                            <td
                              style={{
                                ...tdStyle,
                                fontWeight: 700,
                                color:
                                  Number(detalhe?.total?.diferenca) < 0
                                    ? "#f44335"
                                    : Number(detalhe?.total?.diferenca) > 0
                                    ? "#4caf50"
                                    : undefined,
                              }}
                            >
                              {fmtNumero(detalhe?.total?.diferenca, casas)}
                            </td>

                            <td
                              style={{
                                ...tdStyle,
                                fontWeight: 700,
                              }}
                            >
                              {fmtPercentagem(detalhe?.total?.atingimento_percentagem)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </MDBox>
                  </MDBox>
                </>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={onClose}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <DialogObjetivoV2DashboardVendedorFaturas
        open={!!vendedorFaturas}
        onClose={() => setVendedorFaturas(null)}
        idObjetivo={objetivo?.id}
        vendedor={vendedorFaturas}
      />

      <DialogObjetivoV2DashboardEquipaFaturas
        open={!!equipaFaturas}
        onClose={() => setEquipaFaturas(null)}
        idObjetivo={objetivo?.id}
        equipa={equipaFaturas}
      />
    </>
  );
}
